<mat-list-item
  (click)="!noVersionToCompare && versionClicked.emit(version.version_id)"
  role="button"
  [class.selected-to]="currentSelectedVersionId === version.version_id"
  [class.latest-in-hour]="isLatestInDate"
  [class.other-in-hour]="!isLatestInDate"
  [class.disabled]="noVersionToCompare"
  matTooltip="There aren't any version to compare"
  [matTooltipDisabled]="!noVersionToCompare"
  class="version-list-item">
  <div class="version-time">
    {{ version.created_at | date: 'shortTime' }}
    <button
      *appRequiredRoles="[{ role: 'admin', status: ['DRAFTING', 'IN_REVIEW'] }]"
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="versionMenu"
      mat-icon-button>
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #versionMenu="matMenu">
      <button (click)="openUpdateVersion()" mat-menu-item>
        <mat-icon>badge</mat-icon>
        <span>Alias/tag version</span>
      </button>
      <button (click)="restoreVersion()" mat-menu-item>
        <mat-icon>restore_page</mat-icon>
        <span>Restore version</span>
      </button>
    </mat-menu>
  </div>

  <div class="version-main-info">
    <div class="alias-title" [title]="version.alias || 'No Alias'">
      @if (version.alias) {
        {{ version.alias }}
      } @else {
        {{ version.created_at | date: 'MMMM d' }}
      }
    </div>

    @if (version.restored_version_alias) {
      <span class="restored-item" [title]="'Restored from ID: ' + version.restored_version_id">
        <mat-icon class="restored-icon" fontIcon="undo"></mat-icon>
        Restored from: {{ version.restored_version_alias }}
      </span>
    }
  </div>

  <div class="tags-container">
    @if (isLatestInDate && otherVersionsCount > 0) {
      <button
        class="expand-toggle"
        (click)="$event.stopPropagation(); expandToggled.emit()"
        [attr.aria-expanded]="isExpanded"
        title="{{ otherVersionsCount }} more versions this hour">
        {{ otherVersionsCount }} more
        <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    } @else if (version.tags && version.tags.length > 0) {
      <mat-chip-set class="tag-chip-set">
        @for (tag of version.tags; track tag) {
          <mat-chip class="version-tag">
            {{ tag }}
          </mat-chip>
        }
      </mat-chip-set>
    }
  </div>
</mat-list-item>
